import { RootState } from "@/store";
import { QSO } from "@/types/qso.types";

export const selectAllQSOs = (state: RootState): QSO[] => state.qsos.qsos;
export const selectQSOLoading = (state: RootState): boolean => state.qsos.loading;
export const selectQSOError = (state: RootState): string | null => state.qsos.error;
export const selectImportProgress = (state: RootState): number => state.qsos.importProgress;
export const selectDuplicateCount = (state: RootState): number => state.qsos.duplicateCount;
